<template>

    <div>

        <!-- MODAL -->
		<modal
			:width="modal.width"
			:title="modal.title"
			transition="fadeDown"
			cancel-text="Abbrechen"
			:show-ok="false"
			:backdrop-closable="false"
			:is-show="showModal"
			@close="closeModal">

                <template v-if="modal.isLoading || progressStatus == null">
                    <loading-indicator></loading-indicator>
                </template>

                <template v-else>

                    <template v-if="progressStatus.status != 'Finished'">

                        <template v-if="progressStatus.status == 'Error'">

                            <div class="has-text-centered" style="margin-bottom: 5px;">
                                PROBLEM ...:<br />
                                <span style="color: red; ">{{ progressStatus.log }}</span>
                            </div>

                        </template>

                        <template v-else>

                            <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                            <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                        </template>

                    </template>

                    <template v-else>

                        <div class="has-text-centered">
                            <span class="button is-success" @click="download()">
                                <span class="icon is-small"><i class="icon-ak-download"></i></span>
                                <span>Download</span>
                            </span>
                        </div>

                    </template>


                </template>

        </modal>


    </div>



</template>



<script>


export default {

    props: {
        api: {
            type: String,
            default: null,
            required: true
        },
        title: {
            type: String,
            default: 'Download'
        },
        width: {
            type: Number,
            default: 460,
        },
        show: {
            type: Boolean,
            default: false
        }

    },


    data() {

        return {

            modal: {
                title: this.title,
                width: this.width,
                isLoading: true,
            },

            refreshIntervalId: null,
            progressStatus: null,
            showModal: false

        }
    },

    created() {


    },

    mounted() {

        this.showModal = this.show;
        this.fetchData();

    },

    beforeDestroy () {


    },

    methods: {

        closeModal() {

            clearInterval(this.refreshIntervalId);
            this.progressStatus = null;
            this.refreshIntervalId = null;
            this.showModal = false;

            this.$emit('close');
        },

        download() {

            let url = this.$config.assets + this.progressStatus.log;
            window.open(url, '_blank');
            this.closeModal();

        },

        fetchData() {

            this.modal.isLoading = true;
            var self = this;

            this.axios.get(this.$config.api + this.api)
                .then(response => {

                    self.modal.isLoading = false;
                    var taskLogId = response.data.taskLogId;

                    self.refreshIntervalId = setInterval(function() {

                        self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                            .then(function(response) {

                                self.progressStatus = response.data;

                                if(['Finished', 'Error'].indexOf(response.data.status) > -1) {
                                    clearInterval(self.refreshIntervalId);
                                }

                            });

                    }.bind(self), 800);

                });


        },

    }

}
</script>


<style scoped>

</style>
